module.exports = __webpack_public_path__ + "static/media/ta-01.e1195e95.png";